import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../../../LoadingComponent/LoadingComponent';
import { oneBtnPopupCreator, twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';
import get from 'lodash/get';
import {
  AddressesContainer,
  AddressColumn,
  AddressLineItem,
  ActionPageContainer,
  Title,
  Paragraph,
  ControlsContainer,
  BackButton,
  ActionButton,
} from './ShipstationCreateLabel.styles';

class ShipstationCreateLabel extends Component {
  _isMounted = false;

  static propTypes = {
    selectedOrder: PropTypes.object.isRequired,
    selectedShop: PropTypes.string.isRequired,
    selectedConfig: PropTypes.object.isRequired,
    selectedToolDomains: PropTypes.object.isRequired,
    selectedTicket: PropTypes.object,
    setSelectedTask: PropTypes.func,
    getShipstationOrder: PropTypes.func,
    createShipstationReturnLabel: PropTypes.func,
  };

  static defaultProps = {
    setSelectedTask: () => {},
    getShipstationOrder: () => Promise.resolve(),
    createShipstationReturnLabel: () => Promise.resolve(),
  };

  state = {
    shipstationOrder: {},
    isFetchingShipstationOrder: true,
    isCreateLabelRequesting: false,
    isPolicyAccepted: false,
    isOrderHasShippedStatus: false,
    isSuccessCreatedLabel: false,
    returnLabel: {},
  };

  componentDidMount() {
    this._isMounted = true;
    this.processAPIRequest(
      this.fetchShipstationOrder,
      this.handleSuccessGetShipstationOrder,
      this.handleFailedGetShipstationOrder,
      'isFetchingShipstationOrder'
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Process API request with side effects
   * @param {Function<Promise>} request
   * @param {Function} successHandler
   * @param {Function} errorHandler
   * @param {string} [stateKey] - like this.state[stateKey]
   * @return {Promise<void>}
   */
  processAPIRequest = async (request, successHandler, errorHandler, stateKey) => {
    if (this._isMounted && stateKey) {
      this.setState({ [stateKey]: true });
    }
    try {
      const data = await request();
      successHandler(data);
    } catch (error) {
      errorHandler(error);
    }
    if (this._isMounted && stateKey) {
      this.setState({ [stateKey]: false });
    }
  };

  handleBackBtnClick = () => this.props.setSelectedTask(null);

  getPayloadParams = async () => ({
    simplrAccountId: this.props.selectedTicket.simplrAccountPtrId,
    shopName: this.props.selectedShop,
    orderNumber: this.props.selectedOrder.name.replace('#', ''),
  });

  fetchShipstationOrder = async () => {
    const params = await this.getPayloadParams();

    return await this.props.getShipstationOrder(params);
  };

  handleSuccessGetShipstationOrder = (shipstationOrder) => {
    // TODO: clear this after set shipstation test environment
    const isOrderHasShippedStatus = !shipstationOrder.returnPossible;
    // const isOrderHasShippedStatus = shipstationOrder.returnPossible;

    if (this._isMounted) {
      this.setState({ shipstationOrder, isOrderHasShippedStatus });
    }
  };

  handleFailedGetShipstationOrder = (error) => {
    oneBtnPopupCreator({
      content: {
        main: 'Failed to get order details',
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  handleCreateLabelBtnClick = () => {
    twoBtnPopupCreator({
      content: {
        main: 'Are you sure you want to create return label for order?',
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'CREATE LABEL',
      },
      onConfirm: () =>
        this.processAPIRequest(
          this.createReturnLabelRequest,
          this.handleSuccessCreateLabel,
          this.handleFailedCreateLabel,
          'isCreateLabelRequesting'
        ),
    });
  };

  createReturnLabelRequest = async () => {
    const params = await this.getPayloadParams();

    return await this.props.createShipstationReturnLabel(params);
  };

  handleSuccessCreateLabel = (data) => {
    if (this._isMounted) {
      this.setState({
        isSuccessCreatedLabel: true,
        returnLabel: {
          trackingNumber: data.trackingNumber,
          publicLabelURL: data.publicLabelURL,
        },
      });
    }
    // TODO: add create conversation/shopify order notes
    // TODO: set reply to customer suggestion text with label url
  };

  handleFailedCreateLabel = (error) => {
    oneBtnPopupCreator({
      content: {
        main: 'Return Label creating failed',
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  getPolicyText() {
    return get(this.props.selectedToolDomains, 'shipstationConfig.returnLabelConfig.policy', []).join('\n\n');
  }

  meetsCondition = () => (
    <div>
      <img src="/images/checkmark-green.svg" alt="" />
      <p className="policy-alert">You can create return label for this order</p>
      <div className="row">
        <div className="col-xs-12 text-center">
          <ActionButton type="button" onClick={() => this.setState({ isPolicyAccepted: true })}>
            {' '}
            GO
          </ActionButton>
        </div>
      </div>
    </div>
  );

  notMeetsCondition = () => (
    <div>
      <img src="/images/x-green.svg" alt="" />
      <p className="policy-alert">You are not allowed to create the return label for the order which is not shipped</p>
      <div className="row">
        <div className="col-xs-12 text-center">
          <ActionButton type="button" onClick={this.handleBackBtnClick}>
            {' '}
            BACK TO ACTIONS
          </ActionButton>
        </div>
      </div>
    </div>
  );

  renderCheckPolicy = () => (
    <div className="policy-page text-center">
      <div className="flex-content">
        <img src="/images/magnified-document.svg" className="top-image" alt="" />
        <p className="policy-title">What is the Create Return Label policy?</p>
        {this.getPolicyText()}
        <hr className="policy-divider" />
        {this.state.isOrderHasShippedStatus ? this.meetsCondition() : this.notMeetsCondition()}
      </div>
    </div>
  );

  successCreatedLabelPlaceholder() {
    const { trackingNumber, publicLabelURL } = this.state.returnLabel;

    return (
      <ActionPageContainer>
        <Title>Create Return Label via Shipstation</Title>
        <img src="/images/checkmark-green.svg" className="top-image" alt="" />
        <Paragraph className="policy-title">Return label was successful created</Paragraph>
        <hr className="policy-divider" />

        <p className="policy-title">Label tracking number: ${trackingNumber}</p>
        <p className="policy-title">
          <span>Return Label link</span> <code>{publicLabelURL}</code>
        </p>

        <ControlsContainer>
          <BackButton type="button" onClick={this.handleBackBtnClick}>
            BACK
          </BackButton>
          <ActionButton type="button" onClick={this.handleBackBtnClick}>
            REPLY TO CUSTOMER
          </ActionButton>
        </ControlsContainer>
      </ActionPageContainer>
    );
  }

  render() {
    if (this.state.isCreateLabelRequesting) {
      return <Loading label="Create Return Label..." />;
    }
    if (this.state.isFetchingShipstationOrder) {
      return <Loading label="Get Shipstation order details..." />;
    }
    if (!this.state.isPolicyAccepted) {
      return this.renderCheckPolicy();
    }
    if (this.state.isSuccessCreatedLabel) {
      return this.successCreatedLabelPlaceholder();
    }
    const { orderId, shipTo } = this.state.shipstationOrder;

    return (
      <ActionPageContainer>
        <Title>Create Return Label via Shipstation</Title>
        <Paragraph>{this.getPolicyText()}</Paragraph>
        <hr className="policy-divider" />

        <p className="policy-title">Shipstation order #{orderId}</p>

        <AddressesContainer>
          <AddressColumn>
            <h4>From address</h4>
            <AddressLineItem>Name: {shipTo.name}</AddressLineItem>
            <AddressLineItem>Phone: {shipTo.phone}</AddressLineItem>
            <AddressLineItem>Country: {shipTo.country}</AddressLineItem>
            <AddressLineItem>Post code: {shipTo.postalCode}</AddressLineItem>
            <AddressLineItem>City: {shipTo.city}</AddressLineItem>
            <AddressLineItem>State: {shipTo.state}</AddressLineItem>
            <AddressLineItem>
              Street: {[shipTo.street1, shipTo.street2, shipTo.street3].filter((i) => i).join(', ')}
            </AddressLineItem>
          </AddressColumn>
          <AddressColumn>
            <h4>To address</h4>
            <AddressLineItem>[Shop address]</AddressLineItem>
          </AddressColumn>
        </AddressesContainer>
        <ControlsContainer>
          <BackButton type="button" onClick={this.handleBackBtnClick}>
            BACK
          </BackButton>
          <ActionButton type="button" onClick={this.handleCreateLabelBtnClick}>
            CREATE LABEL
          </ActionButton>
        </ControlsContainer>
      </ActionPageContainer>
    );
  }
}

export default ShipstationCreateLabel;
